import $ from 'jquery';
import { isEmpty } from 'lodash';
import Cookies from 'js-cookie';

import { InventorySearchEvents } from '../events';
import { GarageAPIService } from './api-service';

const dsp = (global.dsp = global.dsp || {});

export class GarageTool {
  #service = new GarageAPIService();

  static GARAGE_COOKIE_NAME = 'garage_store';

  static get default() {
    if (!dsp.garage) {
      dsp.garage = new GarageTool();
    }

    return dsp.garage;
  }

  constructor(options = {}) {
    this.checkboxSelector = options.checkboxSelector || '[data-garage-toggle-id]';
    this.removeButtonSelector = options.removeButtonSelector || '[data-garage-remove-id]';
    this.resetButtonSelector = options.resetButtonSelector || '[data-garage-reset]';
  }

  isEmpty() {
    return isEmpty(this.#getStore().items);
  }

  has(id) {
    const store = this.#getStore();
    return store.items.includes(id);
  }

  add(id) {
    this.#triggerEvent(InventorySearchEvents.GARAGE_ITEM_ADD, { id });
    const store = this.#getStore();
    // await this.#service.addVehicle(id);
    store.items = store.items.concat(id);
    this.#setStore(store);
    this.#triggerEvent(InventorySearchEvents.GARAGE_ITEM_ADDED, { id });
  }

  remove(id) {
    this.#triggerEvent(InventorySearchEvents.GARAGE_ITEM_REMOVE, { id });
    const store = this.#getStore();
    // await this.#service.removeVehicle(id);
    store.items = store.items.filter((itemId) => itemId !== id);
    this.#setStore(store);
    this.#triggerEvent(InventorySearchEvents.GARAGE_ITEM_REMOVED, { id });
  }

  reset() {
    this.#triggerEvent(InventorySearchEvents.GARAGE_CLEAR);
    const store = this.#getStore();
    // await this.#service.clearAll();
    store.items = [];
    this.#setStore(store);
    this.#triggerEvent(InventorySearchEvents.GARAGE_CLEARED);
  }

  #triggerEvent(event, data) {
    $(document).trigger(event, data);
  }

  #getStore() {
    let _store = { items: [] };

    const cookie = Cookies.get(GarageTool.GARAGE_COOKIE_NAME);
    if (cookie) {
      _store = JSON.parse(cookie);
    }

    return _store;
  }

  #setStore(data) {
    Cookies.set(GarageTool.GARAGE_COOKIE_NAME, JSON.stringify(data), {
      expires: 1,
      secure: true,
    });
    this.#triggerEvent(InventorySearchEvents.GARAGE_UPDATED);
  }
}
